/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { computed } from 'vue'
import { useStore } from 'vuex'


export default function ComponentUtil() {

  const nest = (items: any, id = null, link = 'parentId') =>
    items
      .filter((item: { [x: string]: any; }) => item[link] === id)
      //.sort((x: { [x: string]: any; }) => x['order'] ?? 0)
      .map((item: { id: any; }) => ({ ...item, children: nest(items, item.id).sort((a: { order: any; }, b: { order: any; }) => { return (a.order ?? 0) - (b.order ?? 0); }) }));



  const getTreeObject = (element: any, field: string, data = Array<any>()) => {
    if (element[field]) {
      data.push(element[field] as any);
      
      
    } 
    if (element.children != null) 
    {
      for (var i = 0; i < element.children.length; i++) {
        getTreeObject(element.children[i] as any, field, data);
      }
    }
    return data;
  }


  const getTreeFlat = (element: any, field: string, data = Array<any>()) => {
    
    if (element[field]) {
      data.push(element as any);
      
      
    } 
    if (element.children != null) 
    {
      for (var i = 0; i < element.children.length; i++) {
        getTreeFlat(element.children[i] as any, field, data);
      }
    }
    return data;
  }

  const convertTreeToFlat = (element: any, data = Array<any>()) => {
    
    
      data.push(element as any);
    
    if (element.children != null) 
    {
      for (var i = 0; i < element.children.length; i++) {
        convertTreeToFlat(element.children[i] as any,  data);
      }
    }
    return data;
  }

  return {
    nest,
    getTreeObject,
    getTreeFlat,
    convertTreeToFlat
  }

}



